import useColor from '@/hooks/domain/useColor';

const TreeBranchLineIcon = () => {
  const colors = useColor();
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin: '0px 0px 8px 0px' }}
    >
      <path d="M1 1V11H11" stroke={colors.gray400} strokeLinecap="square" />
    </svg>
  );
};

export default TreeBranchLineIcon;
